import { useGraphql } from 'utils/hooks/useGraphql';

import { fetchCampaignStatesQuery } from 'api/queries';

export function useCampaignStateOptions() {
  const { data: campaignStatesData = {} } = useGraphql(fetchCampaignStatesQuery);

  const campaignStates: string[] = campaignStatesData?.campaignStates || [];

  return [campaignStates] as const;
}
